<template>
  <leave-of-absence-report type="My Leave of Absence Report">
  </leave-of-absence-report>
</template>

<script>
import LeaveOfAbsenceReport from "./LeaveOfAbsenceReport.vue";
export default {
  components: {
    LeaveOfAbsenceReport,
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Leave/MyLeaveOfAbsenceReport.vue